var map = {
	"./": 137,
	"./Clutch": 2692,
	"./Clutch.js": 2692,
	"./NewUi": 2693,
	"./NewUi.js": 2693,
	"./OldUi": 2694,
	"./OldUi.js": 2694,
	"./index": 137,
	"./index.js": 137,
	"./style": 857,
	"./style.js": 857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4219;